export const getKeysByTrueValue = (obj: { [key: string]: boolean }): string[] => {
    const keysArray = [];
    for (const key in obj) {
        // eslint-disable-next-line no-prototype-builtins
        if (obj.hasOwnProperty(key) && obj[key]) {
            keysArray.push(key);
        }
    }
    return keysArray;
};
